import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCheckmark = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 28,
	height: 28,
	viewBox: "0 0 28 28",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		fill: "none",
		fillRule: "evenodd",
		children: [/* @__PURE__ */ _jsx("path", {
			stroke: "#000",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1.5,
			d: "m24 8.34-13 13-7-7"
		}), /* @__PURE__ */ _jsx("path", { d: "M0 .841h28v28H0z" })]
	})
});
export default SvgCheckmark;
